import { Stack } from "@mui/material";
import { Pill, Text, Title } from "@src/appV2/redesign/system/ui-components";

import { PageHeaderTopRow } from "../../../components/PageHeaderTopRow";

interface ShiftDoubleBottomSheetHeaderProps {
  workplaceName: string;
  onClose: () => void;
}

export function ShiftDoubleBottomSheetHeader(props: ShiftDoubleBottomSheetHeaderProps) {
  const { workplaceName, onClose } = props;

  return (
    <Stack
      sx={(theme) => ({
        paddingTop: 6,
        paddingBottom: 7,
        paddingX: 5,
        background: theme.palette.shift?.double?.gradient,
      })}
      spacing={4}
    >
      <PageHeaderTopRow sx={{ paddingX: 0, paddingBottom: 3 }} onClickBack={onClose} />

      <Stack sx={{ paddingLeft: 3 }} spacing={4}>
        <Title variant="h3" component="h2">
          {workplaceName}
        </Title>

        <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
          Book back-to-back shifts and work a double
        </Text>

        <Pill
          size="small"
          variant="filled"
          label="Double available"
          iconType="block-shift"
          sx={{
            width: "fit-content",
            // eslint-disable-next-line no-restricted-syntax
            backgroundColor: "rgba(255, 255, 255, 0.85)",
          }}
        />
      </Stack>
    </Stack>
  );
}
